import { Animation } from 'blaze-components/Animations/Animation'
import drafting from 'screens/BrandKits/components/BrandVoice/AddVoice/Processing/analyzing.json'
import finalizing from 'screens/BrandKits/components/SourceMaterialModal/Processing/finalizing.json'
import analyzing from './analyzing.json'
import { Text } from 'blaze-ui/Text/Text'
import Styles from 'screens/BrandKits/components/BrandVoice/AddVoice/Processing/Processing.module.scss'
import { useInterval } from 'react-use'
import { useState } from 'react'
import { Button } from 'blaze-ui/Button'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'

interface Props {
  onCancel: () => void
}

export const Processing = ({ onCancel }: Props) => {
  const [step, setStep] = useState(0)
  useInterval(
    () => {
      setStep((step) => step + 1)
    },
    step === 2 ? null : 4 * 1000, // 4 seconds per slide
  )
  const animationProps = { play: true, style: { width: 85, height: 85 } }

  return (
    <div className={Styles.content}>
      <div />
      <div className={Styles.animation}>
        {step === 0 && (
          <>
            <Animation animationData={analyzing} {...animationProps} />
            <Text variant="primary">
              Analyzing your webpage
              <LoadingEllipses />
            </Text>
          </>
        )}
        {step === 1 && (
          <>
            <Animation animationData={finalizing} {...animationProps} />
            <Text variant="primary">
              Understanding your business
              <LoadingEllipses />
            </Text>
          </>
        )}
        {step === 2 && (
          <>
            <Animation animationData={drafting} {...animationProps} />
            <Text variant="primary">
              Drafting your content plan
              <LoadingEllipses />
            </Text>
          </>
        )}
      </div>
      <div className={Styles.buttonContainer}>
        <Button variant="tertiary" onPress={onCancel} size="lg">
          Cancel
        </Button>
      </div>
    </div>
  )
}
